import styled from 'styled-components'

export const Footer = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${props => props.theme.spacing.sp12};
  padding-top: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.primary};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const CountText = styled.p`
  font-size: 14px;
  line-height: ${props => props.theme.size.XS};
  color: ${props => props.theme.colors.text.muted};
  margin: 0;
`
